export default "/images/recruit-manage-jobs.webp?b3d64153bc86f8d142f898b227b9fbb1";